// Default base structure for configuration
const defaultConfigurationSettings = {
  assets: {
    positions: {
      formImage: 'RIGHT',
    },
    images: {
      home: {
        desktop: null,
        tablet: null,
        smartphone: null,
      },
      form: {
        desktop: null,
        tablet: null,
        smartphone: null,
      },
      finish: {
        desktop: null,
        tablet: null,
        smartphone: null,
        logo: null,
      },
    },
    colors: {
      home: {
        background: '',
        buttonBackground: '',
        buttonFont: '',
        input: '',
      },
      form: {
        buttonBackground: '',
        buttonFont: '',
        toolbar: '',
      },
      finish: {
        background: '',
        buttonBackground: '',
        buttonFont: '',
        text: '',
        main: '',
      },
      legalFooter: {
        background: '',
        font: '',
      },
      socialNetworksFooter: {
        background: '',
        font: '',
      },
    },
  },
  fields: {
    natural: [
      {
        name: 'name',
        type: 'FormText',
        width: 50,
        label: 'Nome',
        mask: null,
        placeholder: null,
        validators: {
          required: true,
          min: 2,
          alpha_spaces: true,
        },
        backend: null,
        options: null,
        mandatory: true,
      },
      {
        name: 'surname',
        type: 'FormText',
        width: 50,
        label: 'Sobrenome',
        mask: null,
        placeholder: null,
        validators: {
          required: true,
          min: 2,
          alpha_spaces: true,
        },
        backend: null,
        options: null,
        mandatory: true,
      },
      {
        name: 'phone',
        type: 'FormText',
        width: 50,
        label: 'Celular',
        mask: ['+55 (##) ####-#####', '+55 (##) # ####-####'],
        placeholder: '(99) 9 9999-9999',
        validators: {
          required: true,
          telefoneValido: true,
        },
        backend: null,
        options: null,
        mandatory: true,
      },
      {
        name: 'email',
        type: 'FormText',
        width: 50,
        label: 'E-mail',
        mask: null,
        placeholder: null,
        validators: {
          email: true,
          required: true,
        },
        backend: ['checkUniqueEmail'],
        options: null,
        mandatory: true,
      },
      {
        name: 'birth_date',
        type: 'FormText',
        width: 100,
        label: 'Data de nascimento',
        mask: ['##/##/####'],
        placeholder: 'DD/MM/YYYY',
        validators: {
          required: true,
          dataValida: true,
          idadeMinima: 18,
          idadeMaxima: 110,
        },
        backend: null,
        options: null,
        mandatory: true,
      },
      {
        name: 'gender',
        type: 'FormRadio',
        width: 100,
        label: 'Gênero',
        mask: null,
        placeholder: null,
        validators: {
          required: true,
        },
        backend: null,
        options: [
          {
            label: 'Feminino',
            value: 'F',
          },
          {
            label: 'Masculino',
            value: 'M',
          },
          {
            label: 'Prefiro não informar',
            value: 'U',
          },
        ],
        mandatory: true,
      },
      {
        name: 'address',
        type: 'FormAddress',
        width: 100,
        label: 'Endereço',
        mask: null,
        placeholder: null,
        validators: null,
        backend: null,
        options: null,
        mandatory: true,
      },
      {
        name: 'password',
        type: 'FormPassword',
        width: 100,
        label: 'Senha',
        mask: null,
        placeholder: null,
        validators: {
          required: true,
          min: 6,
        },
        backend: null,
        options: null,
        mandatory: false,
      },
    ],
    legal: [
      {
        name: 'state_registration',
        type: 'FormText',
        width: 100,
        label: 'Inscrição Estadual',
        mask: ['####################################'],
        placeholder: null,
        validators: null,
        backend: null,
        options: null,
        mandatory: true,
      },
      {
        name: 'name',
        type: 'FormText',
        width: 100,
        label: 'Razão social',
        mask: null,
        placeholder: null,
        validators: {
          required: true,
          min: 2,
        },
        backend: null,
        options: null,
        mandatory: true,
      },
      {
        name: 'phone',
        type: 'FormText',
        width: 50,
        label: 'Celular',
        mask: ['+55 (##) ####-#####', '+55 (##) # ####-####'],
        placeholder: '(99) 9 9999-9999',
        validators: {
          required: true,
          telefoneValido: true,
        },
        backend: null,
        options: null,
        mandatory: true,
      },
      {
        name: 'email',
        type: 'FormText',
        width: 50,
        label: 'E-mail',
        mask: null,
        placeholder: null,
        validators: {
          email: true,
          required: true,
        },
        backend: ['checkUniqueEmail'],
        options: null,
        mandatory: true,
      },
      {
        name: 'landline',
        type: 'FormText',
        width: 100,
        label: 'Telefone Contato',
        mask: ['+55 (##) ####-#####', '+55 (##) # ####-####'],
        placeholder: '(99) 9999-9999',
        validators: {
          required: true,
          telefoneValido: true,
        },
        backend: null,
        options: null,
        mandatory: null,
      },
      {
        name: 'address',
        type: 'FormAddress',
        width: 100,
        label: 'Endereço',
        mask: null,
        placeholder: null,
        validators: null,
        backend: null,
        options: null,
        mandatory: true,
      },
      {
        name: 'password',
        type: 'FormPassword',
        width: 100,
        label: 'Senha',
        mask: null,
        placeholder: null,
        validators: {
          required: true,
          min: 6,
        },
        backend: null,
        options: null,
        mandatory: false,
      },
    ],
    allowed_person_types_signup: ['N', 'L'],
  },
  overrides: {
    facebook_pixel_id: null,
    google_analytics_id: null,
    signup_tag: null,
  },
}

export default {
  hotsiteSlot: null,
  productionConfiguration: null,
  previewConfiguration: null,
  currentConfiguration: {}, // Will point to production by default
  colors: {},
  images: {},
  positions: {},
  fields: {},
  overrides: {},
  loading: false,
  error: null,
  validationErrors: {
    tabs: {},
    fields: {},
  },
  defaultConfigurationSettings,
}
